import { KompasCustomXLinesConfigs } from "../../configs/mounts/custom-lines";
import { KompasFramelessConfigs } from "../../configs/mounts/frameless";
import { MountHardware } from "../../entities/hardware";
import { Partition } from "../../entities/partition";
import { CreateManyStrategy } from "../base/creation.strategy";

import {
    CGF300PerimeterConfigs,
    CGF350PerimeterConfigs,
    CGF400PerimeterConfigs,
    CGS200PerimeterConfigs,
    KompasPerimeterConfigs,
    TreviPerimeterConfigs,
    RomanoPerimeterConfigs,
} from "@/app/domain/configs/mounts/perimeter";

/**
 * System: CGF300
 * Mount Type: Perimeter
 *  */

export class CGF300PerimeterNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF300PerimeterConfigs.noDoors(partition!), MountHardware);
    }
}

export class CGF300PerimeterSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF300PerimeterConfigs.slidingDoors(partition!), MountHardware);
    }
}

export class CGF300PerimeterSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF300PerimeterConfigs.swingDoors(partition!), MountHardware);
    }
}

/**
 * System: CGF350
 * Mount Type: Perimeter
 *  */

export class CGF350PerimeterNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF350PerimeterConfigs.noDoors(partition!), MountHardware);
    }
}

export class CGF350PerimeterSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF350PerimeterConfigs.slidingDoors(partition!), MountHardware);
    }
}

export class CGF350PerimeterSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF350PerimeterConfigs.swingDoors(partition!), MountHardware);
    }
}

/**
 * System: CGF400
 * Mount Type: Perimeter
 *  */

export class CGF400PerimeterNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF400PerimeterConfigs.noDoors(partition!), MountHardware);
    }
}

export class CGF400PerimeterSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF400PerimeterConfigs.slidingDoors(partition!), MountHardware);
    }
}

export class CGF400PerimeterSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGF400PerimeterConfigs.swingDoors(partition!), MountHardware);
    }
}

/**
 * System: CGS200
 * Mount Type: Perimeter
 *  */

export class CGS200PerimeterNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGS200PerimeterConfigs.noDoors(partition!), MountHardware);
    }
}

export class CGS200PerimeterSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGS200PerimeterConfigs.slidingDoors(partition!), MountHardware);
    }
}

export class CGS200PerimeterSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(CGS200PerimeterConfigs.swingDoors(partition!), MountHardware);
    }
}

/**
 * System: Kompas
 * Mount Type: Perimeter
 *  */

export class KompasPerimeterNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasPerimeterConfigs.noDoors(partition!), MountHardware);
    }
}

export class KompasPerimeterSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasPerimeterConfigs.slidingDoors(partition!), MountHardware);
    }
}

export class KompasPerimeterSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasPerimeterConfigs.swingDoors(partition!), MountHardware);
    }
}

export class KompasPerimeterCGFDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasPerimeterConfigs.cgfDoors(partition!), MountHardware);
    }
}

/**
 * System: Kompas
 * Design System: Custom X Lines
 *  */

export class KompasCustomXLinesNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasCustomXLinesConfigs.noDoors(partition!), MountHardware);
    }
}

export class KompasCustomXLinesSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            KompasCustomXLinesConfigs.slidingDoors(partition!),
            MountHardware,
        );
    }
}

export class KompasCustomXLinesSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasCustomXLinesConfigs.swingDoors(partition!), MountHardware);
    }
}

export class KompasCustomXLinesCGFDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasCustomXLinesConfigs.cgfDoors(partition!), MountHardware);
    }
}

/**
 * System: Kompas
 * Design System: Frameless
 *  */

export class KompasFramelessNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasFramelessConfigs.noDoors(partition!), MountHardware);
    }
}

export class KompasFramelessSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasFramelessConfigs.slidingDoors(partition!), MountHardware);
    }
}

export class KompasFramelessSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(KompasFramelessConfigs.swingDoors(partition!), MountHardware);
    }
}
/**
 * System: Trevi
 * Mount Type: No mount
 * Door Type: Steel Single Swing
 *  */

export class TreviNoMountSteelSingleSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            TreviPerimeterConfigs.steelSingleSwing(partition!),
            MountHardware,
        );
    }
}

/**
 * System: Trevi
 * Mount Type: No mount
 * Door Type: Steel Double Swing
 *  */
export class TreviNoMountSteelDoubleSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            TreviPerimeterConfigs.steelDoubleSwing(partition!),
            MountHardware,
        );
    }
}

/**
 * System: Trevi
 * Mount Type: No mount
 * Door Type: Steel Single Sliding
 *  */
export class TreviNoMountSteelSingleSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            TreviPerimeterConfigs.steelSingleSliding(partition!),
            MountHardware,
        );
    }
}

/** * System: Trevi
 * Mount Type: No mount
 * Door Type: Steel Double Sliding
 *  */
export class TreviNoMountSteelDoubleSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            TreviPerimeterConfigs.steelDoubleSliding(partition!),
            MountHardware,
        );
    }
}

/** * System: Trevi
 * * Mount Type: No mount
 * Door Type: Steel Multi Sliding
 *  */
export class TreviNoMountSteelMultiSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            TreviPerimeterConfigs.steelMultiSliding(partition!),
            MountHardware,
        );
    }
}

/** * System: Trevi
 * Mount Type: No mount
 * Door Type: Steel Folding
 *  */
export class TreviNoMountSteelFoldingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(TreviPerimeterConfigs.steelFolding(partition!), MountHardware);
    }
}

/** * System: Trevi
 * Mount Type: No mount
 * Door Type: Steel Arch Single Swing
 *  */
export class TreviNoMountSteelArchSingleSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            TreviPerimeterConfigs.steelArchSingleSwing(partition!),
            MountHardware,
        );
    }
}

/** * System: Trevi
 * Mount Type: No mount
 * Door Type: Steel Arch Double Swing
 *  */
export class TreviNoMountSteelArchDoubleSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            TreviPerimeterConfigs.steelArchDoubleSwing(partition!),
            MountHardware,
        );
    }
}

/**
 * System: Romano
 * Mount Type: No mount
 * Door Type: Steel Single Swing
 *  */

export class RomanoNoMountSteelSingleSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            RomanoPerimeterConfigs.steelSingleSwing(partition!),
            MountHardware,
        );
    }
}

/**
 * System: Romano
 * Mount Type: No mount
 * Door Type: Steel Double Swing
 *  */
export class RomanoNoMountSteelDoubleSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            RomanoPerimeterConfigs.steelDoubleSwing(partition!),
            MountHardware,
        );
    }
}
/**
 * System: Romano
 * Mount Type: No mount
 * Door Type: Steel Single Sliding
 *  */
export class RomanoNoMountSteelSingleSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            RomanoPerimeterConfigs.steelSingleSliding(partition!),
            MountHardware,
        );
    }
}

/** * System: Romano
 * Mount Type: No mount
 * Door Type: Steel Double Sliding
 *  */
export class RomanoNoMountSteelDoubleSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            RomanoPerimeterConfigs.steelDoubleSliding(partition!),
            MountHardware,
        );
    }
}

/** * System: Romano
 * * Mount Type: No mount
 * Door Type: Steel Multi Sliding
 *  */
export class RomanoNoMountSteelMultiSlidingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            RomanoPerimeterConfigs.steelMultiSliding(partition!),
            MountHardware,
        );
    }
}

/** * System: Romano
 * Mount Type: No mount
 * Door Type: Steel Folding
 *  */
export class RomanoNoMountSteelFoldingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(RomanoPerimeterConfigs.steelFolding(partition!), MountHardware);
    }
}

/** * System: Romano
 * Mount Type: No mount
 * Door Type: Steel Arch Single Swing
 *  */
export class RomanoNoMountSteelArchSingleSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            RomanoPerimeterConfigs.steelArchSingleSwing(partition!),
            MountHardware,
        );
    }
}

/** * System: Romano
 * Mount Type: No mount
 * Door Type: Steel Arch Double Swing
 *  */
export class RomanoNoMountSteelArchDoubleSwingDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(
            RomanoPerimeterConfigs.steelArchDoubleSwing(partition!),
            MountHardware,
        );
    }
}

/**
 * System: Trevi
 * Mount Type: No mount
 * Door Type: No door
 *  */

export class TreviNoMountNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(TreviPerimeterConfigs.noDoors(partition!), MountHardware);
    }
}

/**
 * System: Romano
 * Mount Type: No mount
 * Door Type: No door
 *  */

export class RomanoNoMountNoDoorHardwaresCreation extends CreateManyStrategy {
    constructor(partition: Partition) {
        super(RomanoPerimeterConfigs.noDoors(partition!), MountHardware);
    }
}
